<template>
  <div>
    <v-row class="justify-center red--text custom-font subtitle-1 mt-12" v-if="expiredMsg">
      Your payment link has been expired !
    </v-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      expiredMsg: false,
      bookingId: this.$route.params.id
    }
  },
  mounted () {
    this.$apollo.query(
        {
          query: require("@/user/api/queries/payment/validate_payment_query.graphql"),
          variables: {
            paymentLinkId: this.bookingId
          }
        }).then((data) => {
          const validatePayment = data.data.validatePaymentLink
          if (validatePayment) {
            validatePayment.isExpired ?
              this.expiredMsg : window.open(validatePayment.paymentUrl, '_self')
          }
      })
  }
}
</script>

<style>

</style>